<template>
  <div class="predictionList-wrapper">
    <div class="predList-content">
      <van-loading vertical class="loading" v-if="isLoading()">loading...</van-loading>

      <template v-for="(list, key, li) in matchList">
        <div class="pred-result" v-if="list.length > 0" :key="li">
          <div class="pred-list" :key="li">
            <template  v-for="(item, index) in list">
              <div class="pred-list-item" :key="index">
                <div class="pred-list-top flex flex-align-center">
                  <router-link :to="toDetails(item)" @click.native="googleEventClick(item)" class="flex flex-align-center">
                  <div class="pred-league-box">
                    <div class="pred-league">
                      <span class="pred-league-logo"><img :src="common.leagueImgGet(item['league']['id'], 18)" @error="common.imgError($event, 'team')" /></span>
                      <span class="pred-league-name">{{ item['league']['fullName'] }}</span>
                    </div>
                    <div class="pred-match">
                      <span class="pred-match-time">{{ matchTime(item['match']['startTime']) }}</span>
                      <!-- <span class="pred-match-ss">89'</span> -->
                      <span class="pred-match-ss" :class="liveSate.includes(item['match']['state']) ? 'pred-match-ss-start' : '' " :title="langConfig.txtLang[langConfig.curLang]['STATE_ARR_FULL'][item['match']['state']]" v-html="gameTime(item)"></span>
                    </div>
                  </div>

                  <div class="pred-team-box">
                    <span class="team-hname">{{ item['match']['homeTeam']['fullName'] }}</span>
                    <span class="team-logo"><img :src="common.teamImgGet(item['match']['homeTeam']['id'], 20)" @error="common.imgError($event, 'team')" /></span>
                    <span class="team-score">{{ scoreFn(item['match']) }}</span>
                    <span class="team-logo"><img :src="common.teamImgGet(item['match']['awayTeam']['id'], 20)" @error="common.imgError($event, 'team')" /></span>
                    <span class="team-aname">{{ item['match']['awayTeam']['fullName'] }}</span>
                  </div>
                </router-link>

                  <el-popover
                    placement="bottom-end"
                    width="375"
                    trigger="hover"
                    :disabled="oddsElPop()"
                    :open-delay="300"
                    :visible-arrow="false"
                    popper-class="live-odds-pop"
                    :popper-options="{boundariesElement: 'body'}"
                    >
                    <div class="live-odds-popover">
                      <div class="live-odds-popover-content">
                        <table class="live-odds-popover-table">
                          <thead>
                            <tr>
                              <th></th>
                              <th colspan="3" class="bgColor-D9D9D9">{{ langConfig.details[langConfig.curLang]['ODDS']['INITIAL_ODDS'] }}</th>
                              <th colspan="3" class="bgColor-FECD05">{{ langConfig.details[langConfig.curLang]['ODDS']['LIVE_ODDS'] }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(oddsItem, oddsIndex) in oddTypeArr" :key="'oddsIndex_' + oddsIndex">
                              <td class="bgColor-FFEABA">{{ oddsItem.name }}</td>
                              <td>{{ typeof(item[oddsItem.init[0]]) != 'undefined' ? oddsCallFn(oddsItem.id, item[oddsItem.init[0]][oddsItem.init[1]], oddsItem.init[1]) : '-' }}</td>
                              <td>{{ typeof(item[oddsItem.init[0]]) != 'undefined' ? oddsCallFn(oddsItem.id, item[oddsItem.init[0]][oddsItem.init[2]], oddsItem.init[2]) : '-' }}</td>
                              <td>{{ typeof(item[oddsItem.init[0]]) != 'undefined' ? oddsCallFn(oddsItem.id, item[oddsItem.init[0]][oddsItem.init[3]], oddsItem.init[3]) : '-' }}</td>
                              <td class="bgColor-FFF8E3" :class="oddsUd(item, oddsIndex, 0)">{{ typeof(item[oddsItem.type[0]]) != 'undefined' ? oddsCallFn(oddsItem.id, item[oddsItem.type[0]][oddsItem.type[1]], oddsItem.type[1]) : '-' }}</td>
                              <td class="bgColor-FFF8E3" :class="oddsUd(item, oddsIndex, 1)">{{ typeof(item[oddsItem.type[0]]) != 'undefined' ? oddsCallFn(oddsItem.id, item[oddsItem.type[0]][oddsItem.type[2]], oddsItem.type[2]) : '-' }}</td>
                              <td class="bgColor-FFF8E3" :class="oddsUd(item, oddsIndex, 2)">{{ typeof(item[oddsItem.type[0]]) != 'undefined' ? oddsCallFn(oddsItem.id, item[oddsItem.type[0]][oddsItem.type[3]], oddsItem.type[3]) : '-' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="pred-odds-box" v-popover:odds-popover="index == 0 ? 'odds-popover' : null" slot="reference" @click="oddsClicElPop(item)">
                      <div class="hp-odds" v-if="item['threeWay']">
                          <span class="hp-odds-title"><i>{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][2] }}</i></span>
                          <span class="hp-odds-num" :class="oddsUd(item, 2, 0)">{{ oddsCallFn(1, item['threeWay']['home'], 'home') }}</span>
                          <span class="hp-odds-num" :class="oddsUd(item, 2, 1)">{{ oddsCallFn(1, item['threeWay']['draw'], 'draw') }}</span>
                          <span class="hp-odds-num" :class="oddsUd(item, 2, 2)">{{ oddsCallFn(1, item['threeWay']['away'], 'away') }}</span>
                      </div>
                      <div class="hp-odds" slot="reference" v-if="item['total']">
                          <span class="hp-odds-title"><i>{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][1] }}</i></span>
                          <span class="hp-odds-num" :class="oddsUd(item, 1, 0)">{{ oddsCallFn(3, item['total']['over'], 'over') }}</span>
                          <span class="hp-odds-num" :class="oddsUd(item, 1, 1)">{{ oddsCallFn(3, item['total']['total'], 'total') }}</span>
                          <span class="hp-odds-num" :class="oddsUd(item, 1, 2)">{{ oddsCallFn(3, item['total']['under'], 'under') }}</span>
                      </div>
                    </div>
                  </el-popover>
                </div>

                <div class="pred-model-box flex">
                  <div class="pred-model-item" v-popover:play-popover="playPopoverShow(item, index, 0)" slot="reference" v-if="item['predWdl'] || (item['predDiffer'] && item['predDiffer']['wdl'])">
                    <router-link :to="toDetails(item, 1)" @click.native="googleEventClick(item, 1)">
                    <div class="pred-model-title">{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][2] }}</div>
                    <div class="pred-play-box">
                      <div class="pred-play-item" v-if="item['predWdl']">
                        <div class="pred-play-type">
                          <i class="magin-icon"><img src="~@/assets/images/marginIcon.svg" /></i>
                          <span>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][1] }}</span>
                        </div>
                        <div class="pred-play-result">
                          <b :class="[{'hp-result': isResult(item, 'predWdl')}]">{{ margin1x2Result(item) }}</b>
                        </div>
                        <div class="pred-play-last" v-if="listDataPro['margin1x2'] && listDataPro['margin1x2'][item['league']['id']]">LAST <span class="blue">{{ listDataPro['margin1x2'][item['league']['id']]['lastCount'] }}</span> HIT <span class="red">{{ listDataPro['margin1x2'][item['league']['id']]['hitrate'] }}</span></div>
                      </div>
                      <div class="pred-play-item" v-if="item['predDiffer'] && item['predDiffer']['wdl']">
                        <div class="pred-play-type">
                          <i class="diff-icon"><img src="~@/assets/images/divergenceIcon.svg" /></i>
                          <span>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][2] }}</span>
                        </div>
                        <div class="pred-play-result">
                          <b :class="[{'hp-result': isResult(item, 'predDiffer', 0)}]">{{ diff1x2Result(item) }}</b>
                        </div>
                        <div class="pred-play-last" v-if="listDataPro['diff1x2'] && listDataPro['diff1x2'][item['league']['id']]">LAST <span class="blue">{{ listDataPro['diff1x2'][item['league']['id']]['lastCount'] }}</span> HIT <span class="red">{{ listDataPro['diff1x2'][item['league']['id']]['hitrate'] }}</span></div>
                      </div>
                    </div>
                  </router-link>
                  </div>

                  <div class="pred-model-item" v-popover:play-popover="playPopoverShow(item, index, 1)" slot="reference" v-if="item['predDiffer'] && item['predDiffer']['ah']">
                    <router-link :to="toDetails(item, 2)" @click.native="googleEventClick(item, 2)">
                    <div class="pred-model-title">{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][5] }}</div>
                    <div class="pred-play-box">
                      <div class="pred-play-item">
                        <div class="pred-play-type">
                          <i class="diff-icon"><img src="~@/assets/images/divergenceIcon.svg" /></i>
                          <span>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][2] }}</span>
                        </div>
                        <div class="pred-play-result">
                          <b :class="[{'hp-result': isResult(item, 'predDiffer', 2)}]" v-html="diffAsianResult(item)"></b>
                        </div>
                        <div class="pred-play-last" v-if="listDataPro['diffAsian'] && listDataPro['diffAsian'][item['league']['id']]">LAST <span class="blue">{{ listDataPro['diffAsian'][item['league']['id']]['lastCount'] }}</span> HIT <span class="red">{{ listDataPro['diffAsian'][item['league']['id']]['hitrate'] }}</span></div>
                      </div>
                    </div>
                  </router-link>
                  </div>

                  <div class="pred-model-item" v-popover:play-popover="playPopoverShow(item, index, 2)" slot="reference" v-if="item['predDiffer'] && item['predDiffer']['ou']">
                    <router-link :to="toDetails(item, 3)" @click.native="googleEventClick(item, 3)">
                    <div class="pred-model-title">{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][3] }}</div>
                    <div class="pred-play-box">
                      <div class="pred-play-item">
                        <div class="pred-play-type">
                          <i class="diff-icon"><img src="~@/assets/images/divergenceIcon.svg" /></i>
                          <span>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][2] }}</span>
                        </div>
                        <div class="pred-play-result">
                          <b :class="[{'hp-result': isResult(item, 'predDiffer', 1)}]">{{ diffOuResult(item) }}</b>
                        </div>
                        <div class="pred-play-last" v-if="listDataPro['diffOu'] && listDataPro['diffOu'][item['league']['id']]">LAST <span class="blue">{{ listDataPro['diffOu'][item['league']['id']]['lastCount'] }}</span> HIT <span class="red">{{ listDataPro['diffOu'][item['league']['id']]['hitrate'] }}</span></div>
                      </div>
                    </div>
                  </router-link>
                  </div>

                  <div class="pred-model-item" v-popover:play-popover="playPopoverShow(item, index, 3)" slot="reference" v-if="item['predScore'] && item['predScore']['score']">
                    <router-link :to="toDetails(item, 4)" @click.native="googleEventClick(item, 4)">
                    <div class="pred-model-title">{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][4] }}</div>
                    <div class="pred-play-box">
                      <div class="pred-play-item">
                        <div class="pred-play-type">
                          <i class="pos-icon"><img src="~@/assets/images/poissonIcon.svg" /></i>
                          <span>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][0] }}</span>
                        </div>
                        <div class="pred-play-result">
                          <b v-for="(val, i) in item['predScore']['score']" :key="i" :class="[{'hp-result hp-result-s': isResult(item, 'predScore', 0, i)}]">{{ val == '1d' ? langConfig.txtLang[langConfig.curLang]['OTHERS'] : val.replace('-', ':') }}</b>
                        </div>
                        <div class="pred-play-last" v-if="listDataPro['poissonScore'] && listDataPro['poissonScore'][item['league']['id']]">LAST <span class="blue">{{ listDataPro['poissonScore'][item['league']['id']]['lastCount'] }}</span> HIT <span class="red">{{ listDataPro['poissonScore'][item['league']['id']]['hitrate'] }}</span></div>
                      </div>
                    </div>
                  </router-link>
                  </div>

                  <div class="pred-model-item" v-popover:play-popover="playPopoverShow(item, index, 4)" slot="reference" v-if="item['predScore'] && item['predScore']['total']">
                    <router-link :to="toDetails(item, 5)" @click.native="googleEventClick(item, 5)">
                    <div class="pred-model-title">{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][1] }}</div>
                    <div class="pred-play-box">
                      <div class="pred-play-item">
                        <div class="pred-play-type">
                          <i class="pos-icon"><img src="~@/assets/images/poissonIcon.svg" /></i>
                          <span>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][0] }}</span>
                        </div>
                        <div class="pred-play-result">
                          <b v-for="(val, i) in item['predScore']['total']" :key="i" :class="[{'hp-result hp-result-s': isResult(item, 'predScore', 1, i)}]">{{ val > 1 ? langConfig.index[langConfig.curLang]['HOT_PRED']['GOALS'].replace('?1', val) : langConfig.index[langConfig.curLang]['HOT_PRED']['GOAL'].replace('?1', val) }}</b>
                        </div>
                        <div class="pred-play-last" v-if="listDataPro['poissonGoal'] && listDataPro['poissonGoal'][item['league']['id']]">LAST <span class="blue">{{ listDataPro['poissonGoal'][item['league']['id']]['lastCount'] }}</span> HIT <span class="red">{{ listDataPro['poissonGoal'][item['league']['id']]['hitrate'] }}</span></div>
                      </div>
                    </div>
                  </router-link>
                  </div>

                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <!-- <div class="pred-result">
        <div class="pred-list">
          <div class="pred-list-item">
            <div class="pred-list-top flex flex-align-center">
              <div class="pred-league-box">
                <div class="pred-league">
                  <span class="pred-league-logo"></span>
                  <span class="pred-league-name">Scottish Championship</span>
                </div>
                <div class="pred-match">
                  <span class="pred-match-time">08:30</span>
                  <span class="pred-match-ss">89'</span>
                </div>
              </div>

              <div class="pred-team-box">
                <span class="team-hname">主队名称主队名称主队名称主队名称主队名称</span>
                <span class="team-logo"></span>
                <span class="team-score">11-22</span>
                <span class="team-logo"></span>
                <span class="team-aname">客队名称客队名称</span>
              </div>

              <el-popover
                placement="bottom-end"
                width="375"
                trigger="hover"
                :open-delay="300"
                :visible-arrow="false"
                popper-class="live-odds-pop"
                :popper-options="{boundariesElement: 'body'}"
                >
                <div class="live-odds-popover">
                  <div class="live-odds-popover-content">
                    <table class="live-odds-popover-table">
                      <thead>
                        <tr>
                          <th></th>
                          <th colspan="3" class="bgColor-D9D9D9">初盘</th>
                          <th colspan="3" class="bgColor-FECD05">即时盘</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="bgColor-FFEABA">AH</td>
                          <td>1.45</td>
                          <td>-1.75</td>
                          <td>4.53</td>
                          <td class="bgColor-FFF8E3 red">1.45</td>
                          <td class="bgColor-FFF8E3 green">-1.75</td>
                          <td class="bgColor-FFF8E3">4.53</td>
                        </tr>
                        <tr>
                          <td class="bgColor-FFEABA">O/U</td>
                          <td>1.45</td>
                          <td>-1.75</td>
                          <td>4.53</td>
                          <td class="bgColor-FFF8E3 red">1.45</td>
                          <td class="bgColor-FFF8E3 green">-1.75</td>
                          <td class="bgColor-FFF8E3">4.53</td>
                        </tr>
                        <tr>
                          <td class="bgColor-FFEABA">1x2</td>
                          <td>1.45</td>
                          <td>-1.75</td>
                          <td>4.53</td>
                          <td class="bgColor-FFF8E3 red">1.45</td>
                          <td class="bgColor-FFF8E3 green">-1.75</td>
                          <td class="bgColor-FFF8E3">4.53</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="pred-odds-box" v-popover:odds-popover slot="reference">
                  <div class="hp-odds">
                      <span class="hp-odds-title"><i>1x2</i></span>
                      <span class="hp-odds-num green">2.45</span>
                      <span class="hp-odds-num">2.5</span>
                      <span class="hp-odds-num red">3.40</span>
                  </div>
                  <div class="hp-odds" slot="reference">
                      <span class="hp-odds-title"><i>O/U</i></span>
                      <span class="hp-odds-num green">2.45</span>
                      <span class="hp-odds-num">2.5</span>
                      <span class="hp-odds-num red">3.40</span>
                  </div>
                </div>
              </el-popover>
            </div>

            <div class="pred-model-box flex">
              <div class="pred-model-item" v-popover:play-popover slot="reference">
                <div class="pred-model-title">1x2</div>
                <div class="pred-play-box">
                  <div class="pred-play-item">
                    <div class="pred-play-type">
                      <i></i>
                      <span>Margin</span>
                    </div>
                    <div class="pred-play-result">
                      <b>Home Win</b>
                    </div>
                    <div class="pred-play-last">LAST <span class="blue">15</span> HIT <span class="red">89%</span></div>
                  </div>
                  <div class="pred-play-item">
                    <div class="pred-play-type">
                      <i></i>
                      <span>Divergence</span>
                    </div>
                    <div class="pred-play-result">
                      <b>Draw</b>
                    </div>
                    <div class="pred-play-last">LAST <span class="blue">15</span> HIT <span class="red">89%</span></div>
                  </div>
                </div>
              </div>

              <div class="pred-model-item">
                <div class="pred-model-title">Asian Handicap</div>
                <div class="pred-play-box">
                  <div class="pred-play-item">
                    <div class="pred-play-type">
                      <i></i>
                      <span>Divergence</span>
                    </div>
                    <div class="pred-play-result">
                      <b>Home Win<em>(-0.5)</em></b>
                    </div>
                    <div class="pred-play-last">LAST <span class="blue">15</span> HIT <span class="red">89%</span></div>
                  </div>
                </div>
              </div>

              <div class="pred-model-item">
                <div class="pred-model-title">Goals Over/Under</div>
                <div class="pred-play-box">
                  <div class="pred-play-item">
                    <div class="pred-play-type">
                      <i></i>
                      <span>Divergence</span>
                    </div>
                    <div class="pred-play-result">
                      <b>Over 2.5 goals</b>
                    </div>
                    <div class="pred-play-last">LAST <span class="blue">15</span> HIT <span class="red">89%</span></div>
                  </div>
                </div>
              </div>

              <div class="pred-model-item">
                <div class="pred-model-title">Correct Scores</div>
                <div class="pred-play-box">
                  <div class="pred-play-item">
                    <div class="pred-play-type">
                      <i></i>
                      <span>Poisson</span>
                    </div>
                    <div class="pred-play-result">
                      <b>1:2</b>
                      <b>1:1</b>
                      <b>2:2</b>
                    </div>
                    <div class="pred-play-last">LAST <span class="blue">15</span> HIT <span class="red">89%</span></div>
                  </div>
                </div>
              </div>

              <div class="pred-model-item">
                <div class="pred-model-title">Goals</div>
                <div class="pred-play-box">
                  <div class="pred-play-item">
                    <div class="pred-play-type">
                      <i></i>
                      <span>Poisson</span>
                    </div>
                    <div class="pred-play-result">
                      <b>3 Goals</b>
                      <b>1 Goal</b>
                    </div>
                    <div class="pred-play-last">LAST <span class="blue">15</span> HIT <span class="red">89%</span></div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div> -->
    </div>

    <el-popover
      ref="odds-popover"
      placement="bottom-end"
      trigger="manual"
      v-model="visible.odds"
      :visible-arrow="false"
      popper-class="my-popover"
      :popper-options="{boundariesElement: 'body'}"
    >
    <div class="popover-tips-box" @click="popoverIsShow('odds', false)">
      <div class="popover-tips-txt">Hover for more data on different odds types.</div>
      <div class="popover-tips-close"></div>
    </div>
    </el-popover>

    <el-popover
      ref="play-popover"
      placement="bottom-end"
      trigger="manual"
      v-model="visible.plays"
      :visible-arrow="false"
      popper-class="my-popover plays-popover"
      :popper-options="{boundariesElement: 'body'}"
    >
    <div class="popover-tips-box" @click="popoverIsShow('plays', false)">
      <div class="popover-tips-txt">Click on the prediction result to view detailed data.</div>
      <div class="popover-tips-close"></div>
    </div>
    </el-popover>


    <van-popup v-model="oddsPopShow" class="van-popup-m"
    :closeable="false"
    :position="'bottom'" 
    get-container="#app">
      <div class="live-odds-top" v-if="Object.keys(oddsPopData).length > 0">
          <div class="live-odds-close" @click="oddsPopClose()"></div>
          <h4><span>{{ oddsPopData['match']['homeTeam']['fullName'] }}</span><em>VS</em><span>{{ oddsPopData['match']['awayTeam']['fullName'] }}</span></h4>
      </div>
      <div class="live-odds-popover" v-if="Object.keys(oddsPopData).length > 0">
        <div class="live-odds-popover-content">
          <table class="live-odds-popover-table">
            <thead>
              <tr>
                <th></th>
                <th colspan="3" class="bgColor-D9D9D9">{{ langConfig.details[langConfig.curLang]['ODDS']['INITIAL_ODDS'] }}</th>
                <th colspan="3" class="bgColor-FECD05">{{ langConfig.details[langConfig.curLang]['ODDS']['LIVE_ODDS'] }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(oddsItem, oddsIndex) in oddTypeArr" :key="'oddsIndex_' + oddsIndex">
                <td class="bgColor-FFEABA">{{ oddsItem.name }}</td>
                <td>{{ oddsCallFn(oddsItem.id, oddsPopData[oddsItem.init[0]][oddsItem.init[1]], oddsItem.init[1]) }}</td>
                <td>{{ oddsCallFn(oddsItem.id, oddsPopData[oddsItem.init[0]][oddsItem.init[2]], oddsItem.init[2]) }}</td>
                <td>{{ oddsCallFn(oddsItem.id, oddsPopData[oddsItem.init[0]][oddsItem.init[3]], oddsItem.init[3]) }}</td>
                <td class="bgColor-FFF8E3" :class="oddsUd(oddsPopData, oddsIndex, 0)">{{ oddsCallFn(oddsItem.id, oddsPopData[oddsItem.type[0]][oddsItem.type[1]], oddsItem.type[1]) }}</td>
                <td class="bgColor-FFF8E3" :class="oddsUd(oddsPopData, oddsIndex, 1)">{{ oddsCallFn(oddsItem.id, oddsPopData[oddsItem.type[0]][oddsItem.type[2]], oddsItem.type[2]) }}</td>
                <td class="bgColor-FFF8E3" :class="oddsUd(oddsPopData, oddsIndex, 2)">{{ oddsCallFn(oddsItem.id, oddsPopData[oddsItem.type[0]][oddsItem.type[3]], oddsItem.type[3]) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import { Toast } from 'vant';
  import DefaultPic from "@/components/defaultPic.vue";
import langConfig from '../../../utils/langConfig';

	export default {
    name: 'predictionList',
    components: {
      DefaultPic,
    },
    
    props: {
      setting: {
        type: Object,
        default: () => {}
      },
      listDataPro: {
        type: Object,
        default: () => {}
      },
      svrTimestamp: {
        type: Number,
        default: () => 0
      },
    },

		data(){
			return{
        matchList: {
          'list': [], // 未完比赛
          'result': [] // 已完比赛
        },
        date: 0,
        svrTimestamps: 0,

        liveSate: [1,2,3,5,10,11,16], //比赛进行中

        oddTypeArr: [
          {
            id:2,
            name:'AH',
            type: ['asian', 'home', 'hand', 'away'],
            init: ['asian', 'homeInit', 'handInit', 'awayInit']

          },
          {
            id:3,
            name:'O/U',
            type: ['total', 'over', 'total', 'under'],
            init: ['total', 'overInit', 'totalInit', 'underInit']
          },
          {
            id:1,
            name:'1x2',
            type: ['threeWay', 'home', 'draw', 'away'],
            init: ['threeWay', 'homeInit', 'drawInit', 'awayInit']
          },
        ],

        visible: {
          odds: false,
          plays: false,
        },

        playPopFlag: true,

        oddsPopShow: false,
        oddsPopData: {},

        processTimeFlag: true, // 进程时间标识
        timeGap: 0, // 服务器时间与客户段时间差值
        proceessTime: null, // 进程定时器
        proceessNum: false, // 进程
        watchFlag: true,

        screenWidth:2000,
      }
		},

    computed: {

    },

    mounted(){
      this.screenWidth = window.innerWidth;
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);
    },

		methods:{
      isLoading(){
        let _listDataPro = this.listDataPro;
        if(Object.keys(_listDataPro).length > 0){
          return false;
        }

        return true;
      },

      // google事件点击统计
      googleEventClick(val, type){
          let _val = val, _type = type, _tab = 0;
          
          if(typeof(_type) == 'undefined'){
            _tab = 'Match'
          }else{
            _tab = this.langConfig.txtLang[this.langConfig.curLang]['PLAY_EVENT'][_type-1];
          }

          let eventName = 'LS_PC_H_Predictions_Match_Click';
          if(this.common.isMobile != 4){
              eventName = 'LS_Webapp_H_Predictions_Match_Click';
          }

          this.common.googleEvent(eventName, {
              '玩法': _tab
          });
      },

      // 跳转内页
      toDetails(val, type){
        let _val = val, _type = type, _matchId = _val['match']['matchId'], _state = _val['match']['state'], _stateArr = this.liveSate, _tab = 0, _homeName = this.common.formalTitle(_val['match']['homeTeam']['fullName']), _awayName = this.common.formalTitle(_val['match']['awayTeam']['fullName']);

        if(typeof(_type) == 'undefined'){
          // goals
          if(_val['predScore'] && _val['predScore']['total']){
            _type = 5;
          }
          // correctScores
          if(_val['predScore'] && _val['predScore']['score']){
            _type = 4;
          }
          // OverUnder
          if(_val['predDiffer'] && _val['predDiffer']['ou']){
            _type = 3;
          }
          // asianHandicap
          if(_val['predDiffer'] && _val['predDiffer']['ah']){
            _type = 2;
          }
          // 1x2
          if(_val['predWdl'] || (_val['predDiffer'] && _val['predDiffer']['wdl'])
          ){
            _type = 1;
          }
        }

        _tab = this.langConfig.txtLang[this.langConfig.curLang]['TAB_TITLE'][_type-1];

        return `/details/${_tab}/${_matchId}/${_homeName}-vs-${_awayName}`;
      },
      // 是否完场规整
      resultCollation(data){
        if(Object.keys(data).length == 0){
          return;
        }

        // if(this.watchFlag){
        //   this.svrTimestamps = this.common.jsonParse(this.svrTimestamp);
        // }

        let _listDataPro = this.listDataPro, 
            _data = this.common.jsonParse(_listDataPro['predList']), 
            //_leagueHitRate = _listDataPro['leagueHitRate'], 
            //_leagueProfit = _listDataPro['leagueProfit'], 
            _matchData = {'list': [], 'result': []};

        for(let key in _data){
          let _state = _data[key]['match']['state'];
          //let _leagueId = _data[key]['league']['id'];

          // if(typeof(_leagueHitRate[_leagueId]) != 'undefined'){ // 命中率
          //   _data[key]['match']['hitRate'] = _listDataPro['leagueHitRate'][_leagueId];
          // }

          // if(typeof(_leagueProfit[_leagueId]) != 'undefined'){ // 盈利率
          //   _data[key]['match']['proFit'] = _listDataPro['leagueProfit'][_leagueId];
          // }

          if(_state == 4){
            _matchData['result'].push(_data[key]);
          }else{
            _matchData['list'].push(_data[key]);
          }

          
        }

        console.log('比赛列表', _matchData)

        this.matchList = _matchData;


        //console.log('完场规整排序', this.filterSet.sort)
        this.sortItemsByType();
      },
      // 排序
      sortItemsByType(){
        let item = this.matchList;

        if(typeof(item) == 'undefined'){
          return;
        }

        // newItem = Object.fromEntries(
        //               Object.entries(item).sort(([, a], [, b]) => a.match.startTime - b.match.startTime)
        //           );

        for(let key in item){
          item[key].sort(function (a, b) {
            return a['match']['startTime'] > b['match']['startTime'] ? 1 : -1; // 时间升序
          });
        }
        

        this.matchList = item;
        
        this.setTodays();
        this.popoverShow();
      },

      // 比赛时间
      matchTime(val){
        let _val = val;
        let _tsz = this.setting.tsz;
        let _time = this.common.getDateByArray(_tsz, _val);
        _val = this.common.dateStr(_time, 'HH:mm');

        return _val;
      },

      // 比分返回
      scoreFn(val){
        let _val = val, _state = _val['state'], _stateArr = [1,2,3,4,5,10,11,16], _homeScore = _val['homeLive']['scoreFull'] || 0, _awayScore = _val['awayLive']['scoreFull'] || 0;

        if(_state == 17){
          return 'VS';
        }

        return _homeScore + '-' + _awayScore;
      },

      // 指数升级
      oddsUd(val, type, hand){ // val-数据, type-指数类型: 0-亚/1-大小/2-欧, hand-指数: 0-主(胜)/1-盘口(平)/2-客(负)
        let current = ['asian','total','threeWay'], prev = ['asianPrev', 'totalPrev', 'threeWayPrev'];
        let handTxt = [['home', 'hand', 'away'],['over', 'total', 'under'],['home', 'draw', 'away']]

        let _val = val, _type = type, _hand = hand, _val1 = 0, _val2 = 0;

        if(typeof(_val[current[_type]]) == 'undefined'){ // 没有当前指数
            return '';
        }

        _val1 = _val[current[_type]][handTxt[_type][_hand]]*1; // 当前指数

        if(typeof(_val[prev[_type]]) == 'undefined'){ // 没有上个指数
            return '';
        }

        _val2 = _val[prev[_type]][handTxt[_type][_hand]]*1; // 上个指数

        if(typeof(_val2) == 'undefined' || _val1 == _val2){
            return '';
        }

        if(_val1 > _val2){
            return 'green';
        }

        if(_val1 < _val2){
            return 'red';
        }
      },

      // 指数返回
      oddsCallFn(ot, val, type){
        let _val = val, _type = type;
        if(typeof(_val) == 'undefined'){
            return '-'
        }

        return this.oddsLuckyChange(ot, _val, _type);
      },

      // 赔率转换
      oddsLuckyChange(ot, val, type2){
        let _val = val, _form = this.setting.oddsForm, _type = ot, _type2 = type2;
        let _typeArr = ['home', 'away', 'over', 'under', 'homeInit', 'awayInit', 'overInit', 'underInit'];

        // if(_type == 1){
        //   return this.common.oddsFromChange(_val, _form);
        // }

        if(_type == 2 || _type == 3){
            if(_typeArr.includes(_type2)){
                _val =  this.common.addValue(_val*1,1);
            }
        }
        if(_type2 == 'hand' || _type2 == 'total' || _type2 == 'handInit' || _type2 == 'totalInit'){
            return _val;
        }

        return this.common.oddsFromChange(_val, _form);
      },

      // margin1x2结果返回
      margin1x2Result(val){
        let _val = val;
        if(_val['predWdl']['win']){
            return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][0];
        }

        if(_val['predWdl']['draw']){
          return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][1];
        }

        if(val['predWdl']['loss']){
          return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][2];
        }
      },

      // diff1x2结果返回
      diff1x2Result(val){
        let  _val = val;

        if(_val['predDiffer']['wdl'] == 2){ // 平
            return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['DRAW'];
        }

        if(_val['predDiffer']['wdl'] == 1){
          return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][0];
        }

        if(_val['predDiffer']['wdl'] == 3){
          return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][2];
        }
      },

      // diffAsian结果返回
      diffAsianResult(val){
        let _val = val;

        if(_val['predDiffer']['ah'] == 1){
          return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][0] + '<em>('+ _val['predDiffer']['ahHand'] +')</em';
        }

        if(_val['predDiffer']['ah'] == 3){
          return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][2] + '<em>('+ (_val['predDiffer']['ahHand'])*-1 +')</em';
        }
      },

      // diffOu结果返回
      diffOuResult(val){
        let  _val = val, _ou = _val['predDiffer']['ou']*1, _ouHand = _val['predDiffer']['ouHand'], _txt = this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['OU_TXT'];

        if(_ouHand > 1){
            _txt = this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['OU_TXT_S'];
        }

        return _txt[_ou - 1].replace('?1', _ouHand);
      },

      // 时间 
      setTodays(){   
        if(this.processTimeFlag){
          this.processTimeFlag = false;
          this.timeDiff();
          this.process_time();
        }
      },

      // 获取比赛时间
      gameTime(val){
        //console.log('时间差', this.timeGap)
        let _val = val['match'];
        let _tsz = this.setting.tsz;
        let _start = _val['state'],
         _titme = this.common.getDateByArray(_tsz, _val['startTime']),
          _realtime = this.common.getDateByArray(_tsz, _val['startHalfTime']), 
          _injuryTime = _val['injuryTime'], 
          _svrtime = this.common.getDateByArray(_tsz, this.svrTimestamps), 
          _nowtitme = this.common.getDateByArray(_tsz, Date.parse(new Date())/1000);
        let _timeOld = this.common.dateStr(_val['startTime'], 'YYYYMMdd');
        let _timeNews = this.common.dateStr(_titme, 'YYYYMMdd');

        if([17].indexOf(_start)>-1){//未开赛
          // let _date = '';
          // if(_timeOld != _timeNews){ // 跨日显示日期
          //   _date = this.common.dateStr(_titme, 'dd/MM') + '\n';
          // }
          return this.langConfig.txtLang[this.langConfig.curLang]['STATE_ARR'][_start];
        }else if([1,3].indexOf(_start)>-1){//上下半场
          var bssj = 1;

          if(typeof(_realtime) != 'undefined' && typeof(_val['startHalfTime']) != 'undefined'){
            _titme = _realtime;
          }

          if(_start==1){
            bssj = parseInt((_svrtime - _titme) / 60) + this.timeGap;
            if (bssj < 1){
              bssj = 1;
            }
            if (bssj > 45){
              bssj = 45;
            }
          }else{
            bssj = parseInt((_svrtime - _titme) / 60) + 45 + this.timeGap;
            if (bssj < 46){
              bssj = 46;
            }
            if (bssj > 90){
              bssj = 90;
            }
          }
          
          if(typeof(_injuryTime) != 'undefined' && bssj == 90){
            bssj = "<em class=\"flickerBox\">90+'</em>";
          }else{
            bssj += "<em class=\"flickerBox\">'</em>";
          }
          
          return bssj;
        }else if([2,4,5,6,8,11,13,14,15].indexOf(_start)>-1){//其它状态
          return this.langConfig.txtLang[this.langConfig.curLang]['STATE_ARR'][_start];
        }
        return "";
      },

      // 更新进程时间
      process_time: function () {
        if(this.proceessNum){
          if(this.watchFlag){
            this.watchFlag = false;
          }
          this.svrTimestamps += 60;
          //this.emitObj.svrTimestamp = this.svrTimestamp;
          //this.$emit('rechangList', this.emitObj);
          
        }else{
          this.proceessNum = true;
        }

        if (typeof(this.proceessTime) == "number"){
          clearTimeout(this.proceessTime);
        }
        this.proceessTime = setTimeout(this.process_time, 60*1000);
      },

      // 服务器和客户端时间差
      timeDiff(){
        let _svr = new Date(this.common.jsonParse(this.svrTimestamp)*1000), _clt = new Date();
        //console.log('服务器时间', _svr)
        this.timeGap = parseInt((_svr - _clt) / 1000 / 60);
        console.log('服务器和客户端时间差', this.timeGap)
      },

      // 是否显示预测结果
      /**
       * @param val 
       * @param model predScore, predWdl, predDiffer
       * @param type  predScore: 0-scoreHit, 1-totalHit; predWdl: 0-win, 1-draw, 2-loss; predDiffer: 0-wdlHit, 1-ouHit, 2-ahHit
       * @param index predScore: score和total的索引
       */
       isResult(val, model, type, index){
        let _val = val, _model = model, _type = type, _index = index, _state = _val['match']['state'];
        let _predScore = ['scoreHit', 'totalHit'], _predWdl = ['win', 'draw', 'loss'], _predDiffer = ['wdlHit', 'ahHit', 'ouHit'];

        if(_state == 4){
          if(typeof(_val[_model]) != 'undefined'){
            if(_model == 'predScore' && _val[_model][_predScore[_type]][_index] == 1){
              return true;
            }

            if(_model == 'predWdl' && _val[_model]['hit'] == 1){
              return true;
            }

            if(_model == 'predDiffer' && typeof(_val[_model][_predDiffer[_type]]) != 'undefined' && _val[_model][_predDiffer[_type]] == 1){
              return true;
            }
          }
        }

        return false;
      },

      // 气泡提示是否可见
      popoverIsShow(type, boo){
        let _val = {...this.visible}, _type = type, _boo = boo;

        _val[_type] = _boo;

        this.visible = _val;

        if(!boo){
          this.common.infoStorage('popoverShow', true);
        }
      },

      // 移动端指数弹窗
      oddsElPop(){
        if(this.screenWidth <= 767){
          return true;
        }else{
          return false;
        }
      },

      oddsClicElPop(val){
        console.log('指数数据', val)
        let _val = val;
        this.oddsPopData = _val;
        if(this.screenWidth > 767){
          this.oddsPopShow = false;
        }else{
          this.oddsPopShow = true;
        }
      },

      oddsPopClose(){
        this.oddsPopShow = false;
      },

      popoverShow(){
        let that = this, _popovers = this.common.getStorage('popoverShow');
      
        if(_popovers != null){
          return;
        }

        if(Object.keys(this.listDataPro).length > 0){
          setTimeout(function(){
            that.popoverIsShow('odds', true);
            that.popoverIsShow('plays', true);
            that.popoverClose();
          }, 500);
        }
      },

      popoverClose(){
        let that = this, _popovers = this.common.getStorage('popoverShow');
      
        if(_popovers != null){
          return;
        }

        setTimeout(function(){
          that.popoverIsShow('odds', false);
          that.popoverIsShow('plays', false);

          that.common.infoStorage('popoverShow', true);
        }, 60*1000);
      },

      // 玩法气泡显示
      playPopoverShow(val, index, li){
        let _val = val, _index = index, _li = li, _num = 5;

        // if(_index > 0){
        //   return null;
        // }
        if(!this.playPopFlag){
          return null;
        }
        
        if(typeof(_val['predWdl']) == 'undefined'){
          _num--;
        }

        if(typeof(_val['predDiffer']) == 'undefined' || typeof(_val['predScore']) == 'undefined'){
          _num -= 2;
        }else{
          if(typeof(_val['predDiffer']['ah']) == 'undefined' || typeof(_val['predDiffer']['ou']) == 'undefined' || typeof(_val['predScore']['score']) == 'undefined' || typeof(_val['predScore']['ou']) == 'total'){
            _num--;
          }
        }

        if(this.screenWidth > 767){
          console.log('屏幕宽度', _num, _li)
          if((5-_num) == _li){
            this.playPopFlag = false;
            return 'play-popover';
          }else{
            return null;
          }
        }else{
          if(_num >= 3){
            if(_li == 3){
              this.playPopFlag = false;
              return 'play-popover';
            }else{
              return null;
            }
          }else{
            if(_num == _li){
              this.playPopFlag = false;
              return 'play-popover';
            }else{
              return null;
            }
          }
        }
      },

      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
          this.screenWidth = window.innerWidth;
        }
      },
      
		},

		created(){
      //this.setTodays();
      //console.log('预测列表', this.listDataPro)
		},

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    },

    destroyed() {
      
    },
    
    watch: {
      'listDataPro.predList': {
        immediate: true,
        deep: true,
        handler(val){
          console.log('预测列表', this.listDataPro)
          this.resultCollation(this.listDataPro);
        }
      },
      'svrTimestamp': {
        immediate: true,
        handler(val){
          //console.log('服务器时间', val)
          this.svrTimestamps = this.common.jsonParse(val);
          this.processTimeFlag = true;
          this.setTodays();
        }
      }
    },
	};

</script>
<style lang="less" scoped>
@import '~@/style/index/homePredictionList.less';
</style>


// WEBPACK FOOTER //
// ./src/views/home/components/homePredictionList.vue